import { CircularProgress, CircularProgressProps, Stack } from '@mui/material';
import { StackProps } from '@mui/system';

interface CircularLoaderProps extends CircularProgressProps {
  stackProps?: StackProps;
}

export function CircularLoader({ stackProps, ...props }: CircularLoaderProps) {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      height="100%"
      {...stackProps}
      aria-label="circular-loader"
    >
      <CircularProgress {...props} />
    </Stack>
  );
}
